import { render, type ComponentType } from "preact";
import type { DeckState } from "./types";
export interface CustomProps { data: Record<string, unknown>; state: DeckState }
function DemoCallout({ data, state }: CustomProps) {
  return <aside class="ss-callout"><strong>{String(data.text ?? "An exceptional slide")}</strong>
    <small> · Step {state.stepIndex}</small></aside>;
}
/** Only explicitly imported, reviewed components enter the static bundle. */
export const customComponents: Record<string, ComponentType<CustomProps>> = { DemoCallout };
export function renderCustom(name: string, host: HTMLElement, data: Record<string, unknown>, state: DeckState) {
  const Component = customComponents[name];
  if (!Component) throw new Error("Unknown custom component: " + name + ". Register it in custom.tsx and build.");
  render(<Component data={data} state={state} />, host);
}
